import React from 'react'
import { FAQEntry } from '../../utils/types'
import FAQRow from './FAQRow'

const FAQAnswer = ({ children }: Readonly<{ children: React.ReactNode }>) => (
    <>{children}</>
)

const faqs: FAQEntry[] = [
  {
    question: 'What does SmartAsset do?',
    answer: (
            <FAQAnswer>
                SmartAsset is a personal finance company focused on empowering people to make smart financial decisions.
                We built this tool to help people find a financial advisor who can help you work toward achieving your
                financial goals.We help thousands of users a month in their search for a financial advisor.
            </FAQAnswer>
    )
  },
  {
    question: 'How does this service work?',
    answer: (
            <FAQAnswer>
                We match you with up to three advisors. Before allowing an advisor on our platform, we verify their
                status as being registered or chartered as fiduciaries (&quot;Adviser(s)&quot;) with a regulatory
                body in the United States.
            </FAQAnswer>
    )
  },
  {
    question: 'How much does it cost?',
    answer: (
            <FAQAnswer>
                SmartAsset’s matching service doesn’t cost you anything. You only pay the advisor if you decide to
                work with them. The advisors on our platform have several different fee structures, so be sure to
                ask your matches about what they charge.
            </FAQAnswer>
    )
  },
  {
    question: 'How should I prepare for my advisor matches?',
    answer: (
            <FAQAnswer>
                You can prepare for your conversation by reading our SmartReads article:
                <a href="https://smartasset.com/financial-advisor/questions-to-ask-a-financial-advisor"
                   target="_blank" rel="noopener noreferrer">10 questions to ask an advisor </a>
            </FAQAnswer>
    )
  }
]

const FAQList = () => {
  return (
        <>
            {faqs.map((faqEntry, index) => (
                <FAQRow key={index} faqEntry={faqEntry} />
            ))}
        </>
  )
}
export default FAQList
